import clsx from 'clsx';
import { useTranslation } from 'next-i18next/pages';
import { useMemo } from 'react';

import { BasePositionCardProps } from '@pflegia/types/common/interfaces/position-card';
import { JobPositionFeature } from '@pflegia/types/common/job-position/features';

import { Badge } from '../badge/Badge.component';
import EmojiText from '../emoji-text';

const JOB_POSITION_FEATURES_UI: { key: JobPositionFeature; className: string; emoji: string }[] = [
  {
    key: 'hasTopSalary',
    emoji: '💰',
    className: 'bg-[#FFEDB8] text-[#5C4900]',
  },
  {
    key: 'hasFastResponse',
    emoji: '⚡️',
    className: 'bg-[#D7FFB8] text-[#3C5E00]',
  },
  {
    key: 'isNewChance',
    emoji: '🆕',
    className: 'bg-[#5C9AFF] text-white',
  },
];

export const FeaturesBadges: React.FC<Pick<BasePositionCardProps, 'featuresBadges'>> = ({ featuresBadges }) => {
  const { t } = useTranslation();
  const availableFeatures = useMemo(() => JOB_POSITION_FEATURES_UI.filter(feature => featuresBadges?.[feature.key]), [featuresBadges]);
  if (!availableFeatures?.length && !featuresBadges?.loading) {
    return null;
  }
  return (
    <div className='mb-2 flex w-full flex-wrap justify-start gap-2 text-xs md:text-sm'>
      {featuresBadges?.loading ? (
        <Badge loading={featuresBadges?.loading} className='w-full py-1 pr-3 pl-2 font-semibold' />
      ) : (
        availableFeatures?.map(({ key, className, emoji }) => (
          <Badge key={key} className={clsx(className, 'no-wrap py-1 pr-3 pl-2 font-semibold')}>
            <EmojiText emoji={emoji} emojiAsText>
              {t(`jobBoard:features.${key}`)}
            </EmojiText>
          </Badge>
        ))
      )}
    </div>
  );
};
